import { useEffect, useState, type ReactNode } from 'react';
import { type SignupResponse } from '@hungryroot/rest';
import { facebookAuth, loadFacebookSdk } from '../../provider/facebook';
import { FacebookIcon } from '../../svg/FacebookIcon';
import { RoundedButton } from '../RoundedButton/RoundedButton';

type Props = {
  onLoginSuccess: (data: SignupResponse) => void;
  onSignupSuccess: (data: SignupResponse) => void;
  onError: () => void;
  /** Marks a freemium (guest-flow) signup if this auth creates an account. */
  isGuestFlow?: boolean;
  children?: ReactNode;
};

export function ButtonFacebook({
  onLoginSuccess,
  onError,
  onSignupSuccess,
  isGuestFlow,
  children,
}: Props) {
  const [facebookSdk, setFacebookSdk] = useState<fb.FacebookStatic | null>(
    null
  );

  useEffect(() => {
    loadFacebookSdk({
      onReady: setFacebookSdk,
    });
  }, []);

  return (
    <RoundedButton
      disabled={facebookSdk === null}
      onClick={() => {
        if (facebookSdk === null) {
          return;
        }
        facebookAuth({
          fb: facebookSdk,
          onSignupSuccess,
          onLoginSuccess,
          onError,
          isGuestFlow,
        });
      }}
      aria-label="Sign up with Facebook"
    >
      <FacebookIcon /> {children}
    </RoundedButton>
  );
}
